<div class="modal inmodal fade in create-modal show">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal(form)">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">SMS Message</h4>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm increased-text">
                        <div class="col-sm-2 bold">Full Name:</div>
                        <div class="col-sm-10">{{directoryService.smsMessageResidentData.resident.fullName}}</div>
                    </div>
                    <div class="row m-b-sm increased-text">
                        <div class="col-sm-2 bold">Phone:</div>
                        <div class="col-sm-10">
                            <select class="form-control"
                                    name="cellPhone"
                                    [(ngModel)]="cellPhone"
                                    *ngIf="this.directoryService.smsMessageResidentData.cellPhones.length > 1">
                                <option *ngFor="let p of this.directoryService.smsMessageResidentData.cellPhones"
                                        [value]="p.phone">
                                    {{getPhoneString(p.phone)}}
                                </option>
                            </select>
                            <span *ngIf="this.directoryService.smsMessageResidentData.cellPhones.length < 2">
                                {{getPhoneString(cellPhone)}}
                            </span>
                        </div>
                    </div>
                    <div class="form-group" id="summernote">{{message}}</div>
                    <div class="num-of-characters">{{message.length}}/500</div>
                    <div class="row text-center m-t-md">
                        <button class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Send</button>
                    </div>
                    <spinner [spinnerShow]="showSpinner"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal(form)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/send-sms-modal/send-sms-modal.component.html